import { useUserEventLogger } from '@repo/tracking-service';
import { Button } from '@zenterprise-inc/ui';
import Image from 'next/image';
import Link from 'next/link';

import s from './Reviews.module.scss';

import { useUrlWithQueryString } from '@/lib/hooks/use-url-with-query-string';

const ReviewTextCardGrid = () => {
  const signInUrl = useUrlWithQueryString();
  const { sendClickEvent } = useUserEventLogger();

  const sendUserEvent = () => {
    sendClickEvent('landing_review_lookup');
  };

  return (
    <div className={'flex justify-center'}>
      <div className={'app-side-padding flex w-full max-w-screen-lg flex-col items-center py-[6em]'}>
        <div className="heading-8">그간 의심없이 내라는 대로만 내 왔다면,</div>
        <div className={'heading-3 mb-[0.5em] mt-[0.15em] text-center'}>
          이제 대표님께도
          <br />
          <span className="highlight-gradient bznav-main shimmer">환급의 기회</span>가 있습니다.
        </div>
        <p className={'paragraph-1 mb-[1.5em] mt-[0.2em] font-medium'}>성실히 납부한 100만 사업자의 선택, 비즈넵 환급.</p>
        <Link href={signInUrl} className={'mb-[3.625em]'}>
          <Button.Box state={'primary'} size={'large'} className={'rounded-full'} onClick={sendUserEvent}>
            환급금 무료 조회
          </Button.Box>
        </Link>
        <div className={s.text_reviews_wrapper}>
          {TEXT_REVIEW_ITEMS.map((columnData, columnIndex) => (
            <div key={columnIndex} className={s.reviews_columns}>
              {columnData.map((item, reviewIndex) => (
                <div key={reviewIndex} className={s.review_item_card}>
                  <div className={'inline-flex items-center justify-start gap-3.5'}>
                    <div className={'h-[50px] w-[50px] overflow-hidden rounded-full'}>
                      <Image width={'50'} height={'50'} src={item.img} alt={''} />
                    </div>
                    <div className={'font-medium text-gray-700'}>
                      <div className={'text-[12px]'}>{item.business}</div>
                      <div className={'text-[13px] text-black'}>
                        <span className={'text-[17px] font-bold'}>{item.refund}</span>원 환급받음
                      </div>
                    </div>
                  </div>
                  <div className="heading-4">
                    <div className="paragraph-5 font-normal leading-[1.65] text-black">{item.quote}</div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewTextCardGrid;

const TEXT_REVIEW_ITEMS = [
  [
    {
      img: '/images/illus-icons/reviews/graphic_review9.svg',
      quote: (
        <div>
          평소 내던 대로 세금을 냈을 뿐인데, 내야 하는 것보다 훨씬 더 많이 내고 있었다는 사실에 깜짝 놀랐어요. 다행히{' '}
          <strong className={'font-medium text-violet-500'}>비즈넵 환급으로 더 낸 세금을 모두 돌려받고</strong> 두 달 치 직원 월급 금액을 세이브했어요!
        </div>
      ),
      business: '서울 강서구 카페 운영',
      refund: '5,499,290'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review5.svg',
      quote: (
        <div>
          사무실 임대료가 점점 올라 걱정이었는데, 이번에 돌려받은 환급액으로 석 달 치 임대료를 해결했어요.{' '}
          <strong className={'font-medium text-violet-500'}>비즈넵 환급을 몰랐다면 놓칠 수도 있었던 돈</strong>인데 이렇게 활용할 수 있어 얼마나 다행인지
          몰라요.
        </div>
      ),
      business: '서울 서초구 쇼핑몰 운영',
      refund: '3,847,980'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review8.svg',
      quote: (
        <div>
          이래저래 말리는 목소리도 있었는데, 다들 정확히 어떤게 문제가 되는지는 말씀을 안하시더라고요. 그런데 막상 신청해보니{' '}
          <strong className={'font-medium text-violet-500'}>꼼꼼하게 챙겨주시고 생각지도 못한 큰 금액을 받게 해주셔서 </strong>
          너무 감사했습니다.
        </div>
      ),
      business: '경기 화성시 인테리어 매장 운영',
      refund: '7,293,103'
    }
  ],
  [
    {
      img: '/images/illus-icons/reviews/graphic_review7.svg',
      quote: (
        <div>
          좀 늦은 나이에 도전하는 마음으로 시작한 창업인데, 하루하루 살얼음판을 걷는{' '}
          <strong className={'font-medium text-violet-500'}>저에게 큰 응원이 되어 주었습니다.</strong>
        </div>
      ),
      business: '부산 연제구 양식당 운영',
      refund: '1,942,395'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review4.svg',
      quote: (
        <div>
          사업자금으로 난생 처음 큰 대출을 끌어왔는데, 매월 이자 갚는 것만으로도 힘들더라고요. 물론 큰 금액은 아니지만,{' '}
          <strong className={'font-medium text-violet-500'}>비즈넵 환급 덕분에 이번 달은 한숨 돌릴 수 있게 됐어요.</strong>
        </div>
      ),
      business: '경기 구리시 전자상거래업체 운영',
      refund: '824,021'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review6.svg',
      quote: (
        <div>
          젊은 날 도전과 실패를 많이 겪었습니다. 여러 차례의{' '}
          <strong className={'font-medium text-violet-500'}>창업과 폐업 과정 속에서 이렇게 많은 세금 혜택을 얻을 수 있게 되리라고는 생각을 못했는데,</strong>{' '}
          이게 다 비즈넵 환급 덕분이라고 생각을 합니다.
        </div>
      ),
      business: '전북 익산시 운수업체 운영',
      refund: '13,234,912'
    }
  ],
  [
    {
      img: '/images/illus-icons/reviews/graphic_review1.svg',
      quote: (
        <div>
          6년 동안 사업을 운영하다가 가게 리모델링을 결심했는데요. 사업자 대출도 막히고 지원금도 끊겨 막막하게 느껴질 때쯤 비즈넵 환급을 알게 되었어요. 비즈넵
          환급 덕분에 <strong className={'font-medium text-violet-500'}>클릭 몇 번으로 5년간 제가 더 낸 세금을 전부 찾게 되니</strong>, 부족한 사업 자금이
          메꿔지더라고요.
        </div>
      ),
      business: '수원 고기집 운영',
      refund: '18,457,030'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review2.svg',
      quote: (
        <div>
          환급 금액이 너무 커서 혹시 세무조사를 받게 되는 건 아닌지 걱정했는데,{' '}
          <strong className={'font-medium text-violet-500'}>관할 세무서에서 직접 확인하고 환급 결정되는거라 걱정 할 필요 없다고</strong> 말씀하시더라고요.
          다행히 환급받은 지 3개월이 지난 지금까지도 문제된 적이 없네요!
        </div>
      ),
      business: '서울 관악구 한식집 운영',
      refund: '9,140,400'
    },
    {
      img: '/images/illus-icons/reviews/graphic_review3.svg',
      quote: (
        <div>
          비즈넵 환급에서 조회해본 환급액과 기장 맡기던 <strong className={'font-medium text-violet-500'}>세무사에게 물어본 환급액 차이가 크더라고요.</strong>{' '}
          한 푼이 아쉬운 시국이라 비즈넵 환급을 이용해서 더 많이 돌려받았습니다!
        </div>
      ),
      business: '서울 성동구 공장 운영',
      refund: '7,851,790'
    }
  ]
];
